import { CircularProgress, Grid, Typography } from "@mui/material";
import { useGetClientQuery } from "features/trading/accounts";

export default function ClientProfile({ clientId }: { clientId?: number }) {
  const { data: client, isLoading } = useGetClientQuery(clientId, { skip: !clientId });

  const profile = client ? [
    { name: "Optic ID", value: clientId },
    { name: "Orion ID", value: clientId },
    { name: "Representative", value: client.representative__name },
  ] : undefined;

  return profile ? (
    <Grid container spacing={2}>
      {profile.map((item, index) => (
        <Grid item container spacing={2} key={index}>
          {/* The label column is a quarter of the panel so every value lines up
              underneath the one above it. minWidth keeps the longest label
              ("Representative") from overflowing that quarter and colliding
              with its own value once the panel gets narrow. */}
          <Grid item xs={3} minWidth="fit-content">
            <Typography>{item.name}</Typography>
          </Grid>
          <Grid item xs>
            <Typography>{item.value}</Typography>
          </Grid>
        </Grid>
      ))}
    </Grid>
  ) : <CircularProgress />;
}
